export const locale = {
    lang: 'fr',
    data: {
        PROJECTS_BOARD_DIALOGS_ATTACHEMENT_DISPLAY_CLOSE: 'Fermer',
    }
};
